<template>
    <div class="relative flex flex-col flex-1 min-h-0 bg-stage-background overflow-hidden">
        <div class="stage-page-header">
            <div class="stage-page-header-row">
                <div class="stage-page-header-main">
                    <h1 class="stage-page-title">{{ $t('CMS') }}</h1>
                </div>
            </div>
        </div>

        <div class="stage-page-body stage-page-fill">
            <div class="w-full h-full bg-white shadow sm:rounded relative overflow-hidden flex flex-col min-h-0">
                <div class="relative flex-1 min-h-0 overflow-hidden">
                    <div class="h-full overflow-auto">
                        <div class="hidden sm:block">
                            <div class="align-middle inline-block min-w-full border-b border-ultralight">
                                <table class="table-listview table-listview--zebra">
                                    <thead>
                                    <tr>
                                        <th class="table-listview-l-th">Umfang</th>
                                        <th class="table-listview-l-th">Beschreibung</th>
                                    </tr>
                                    </thead>
                                    <tbody class="bg-white">
                                    <tr
                                        v-for="item in items"
                                        :key="item.route"
                                        class="cursor-pointer"
                                        @click="$router.push(item.route)"
                                    >
                                        <td class="table-listview-l-td whitespace-no-wrap">
                                            <div class="flex items-center">
                                                <div class="mr-3 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gray-700">
                                                    <svg-vue class="h-8 w-8 p-1.5 text-gray-200" :icon="item.icon"></svg-vue>
                                                </div>
                                                <div class="text-sm font-medium text-gray-700">
                                                    {{ item.title }}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="table-listview-l-td">
                                            <div class="text-sm text-gray-500">{{ item.description }}</div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="sm:hidden p-4 space-y-3">
                            <router-link
                                v-for="item in items"
                                :key="'mobile-' + item.route"
                                :to="item.route"
                                class="block border border-bordergray-100 rounded p-3 bg-white"
                            >
                                <div class="flex items-center">
                                    <div class="mr-3 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gray-700">
                                        <svg-vue class="h-8 w-8 p-1.5 text-gray-200" :icon="item.icon"></svg-vue>
                                    </div>
                                    <div class="min-w-0 flex-1">
                                        <div class="text-sm font-medium text-gray-700 truncate">
                                            {{ item.title }}
                                        </div>
                                        <div class="text-xs text-gray-500 mt-1">
                                            {{ item.description }}
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "cms-settings-index",
    computed: {
        items() {
            return [
                {
                    route: '/workspace/cms/templates',
                    title: this.$t('Templates'),
                    description: this.$t('Basistemplates mit HTML, CSS, JS und separaten Uploads.'),
                    icon: 'font-awesome.regular.sidebar',
                },
                {
                    route: '/workspace/cms/languages',
                    title: this.$t('Sprachen'),
                    description: this.$t('CMS-Sprachen, Standardsprache und aktivierte Sprachvarianten.'),
                    icon: 'font-awesome.regular.language',
                },
                {
                    route: '/workspace/cms/pages',
                    title: this.$t('Seiten'),
                    description: this.$t('Fachliche Seiten mit sprachspezifischen Inhalten, Code und Uploads.'),
                    icon: 'font-awesome.regular.copy',
                },
                {
                    route: '/workspace/cms/content-modules',
                    title: this.$t('Content-Module'),
                    description: this.$t('Dynamische Modul-Presets mit Feldschemas, HTML-Varianten und Publish-Status.'),
                    icon: 'font-awesome.regular.cube',
                },
                {
                    route: '/workspace/cms/slots',
                    title: this.$t('Slots'),
                    description: this.$t('Slot-Definitionen für Seiten und Templates inklusive erlaubter Modultypen.'),
                    icon: 'font-awesome.regular.check-to-slot',
                },
                {
                    route: '/workspace/cms/module-library',
                    title: this.$t('Modul-Bibliothek'),
                    description: this.$t('Global gespeicherte, bereits konfigurierte Module für die Wiederverwendung auf mehreren Seiten.'),
                    icon: 'font-awesome.regular.cubes',
                },
                {
                    route: '/workspace/cms/domains',
                    title: this.$t('Domains'),
                    description: this.$t('Hosts, Tokens und Pfad-Zuordnungen für die externe Auslieferung.'),
                    icon: 'font-awesome.regular.plug',
                },
                {
                    route: '/workspace/cms/file-manager',
                    title: this.$t('Dateimanager'),
                    description: this.$t('Öffentliche CMS-Dateien mit Vorschau, URL und Wiederverwendung in Seiten, Templates und Modulen.'),
                    icon: 'font-awesome.regular.folders',
                },
                {
                    route: '/workspace/cms/config',
                    title: this.$t('Konfiguration'),
                    description: this.$t('Status der CMS-CSS und manueller Tailwind-Rebuild bei Bedarf.'),
                    icon: 'font-awesome.regular.gear',
                },
            ];
        },
    },
}
</script>
